import { csv } from "d3-fetch";
import _ from "lodash";
import DATA from "../data/tracers.csv";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(DATA)]).then(([data]) => {
    let cleanData = data.map((datum) => {
      return {
        ...datum,
        tracers_needed: +datum.tracers_needed,
      };
    });
    cleanData = _.orderBy(cleanData, ["tracers_needed"], ["desc"]);
    return cleanData;
  });
};

export default loadData;
